import {
  HeroBg,
  HeroContainer,
  HeroContent,
  HeroH1,
} from "../../styled-components/Home/heroStyles";
import HeroBgImg from "../../images/HeroBg.jpg";
import Image from "next/image";

const Hero = () => {
  return (
    <HeroContainer half>
      <HeroBg>
        <Image
          priority={true}
          alt="Contact Background image"
          src={HeroBgImg.src}
          layout="fill"
          objectFit="cover"
          quality={100}
        />
      </HeroBg>
      <HeroContent>
        <HeroH1 centerText={true}>Contact Us</HeroH1>
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
